// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__AVqYI","DiagArrow":"Button_DiagArrow__KlNlz","gradient":"Button_gradient__lZwEC","primary":"Button_primary__5b61E"};